import React from 'react';
import classnames from 'classnames';
import { withStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import { JSSClasses } from '../../proptypes/jss-prop-types';

/* istanbul ignore next */
const styles = ({ palette: { error, primary, secondary, success, warning } }) => ({
  success: {
    color: success.contrastText
  },
  danger: {
    color: error
  },
  error: {
    color: error
  },
  warning: {
    color: warning.contrastText
  },
  primary: {
    color: primary.contrastText
  },
  secondary: {
    color: secondary.contrastText
  }
});

export function TextColorComponent({ children, className, classes, dataQa, textStyle }) {
  const classNames = classnames(className, classes[textStyle]);

  return (
    <span className={classNames} data-qa={dataQa}>
      {children}
    </span>
  );
}

TextColorComponent.propTypes = {
  classes: JSSClasses,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func])),
    PropTypes.element,
    PropTypes.node,
    PropTypes.func
  ]),
  textStyle: PropTypes.string,
  dataQa: PropTypes.string
};
TextColorComponent.defaultProps = {
  classes: {},
  className: '',
  children: [],
  textStyle: 'default',
  dataQa: ''
};

const TextColorStyled = withStyles(styles)(TextColorComponent);
export default withTheme(TextColorStyled);
